/* eslint-disable */ import { assertBoolean, assertNumber, attributeSwitchComponent, composedOfComponent, dimensionIndicatorComponent, distanceDimensionComponent, memoEval, sceneEntityPropertiesComponent, violationComponent } from '@salsita-ai/platform-project-sdk/domain';
import { attachComponent } from '../implementation.js';
export const wallComponents = [
    attachComponent.withComponent(violationComponent, 'default', true).withEntity('Wall').attach(memoEval((s)=>[
            s.$violations
        ], (violations)=>{
        return {
            violations
        };
    })),
    attachComponent.withComponent(composedOfComponent, '$bottomItems', true).withEntity('Wall').attach(memoEval((self)=>self.$bottomItems.map((entity)=>entity.id), (...ids)=>({
            childEntityIds: ids
        }))),
    attachComponent.withComponent(composedOfComponent, '$topItems', true).withEntity('Wall').attach(memoEval((self)=>self.$topItems.map((entity)=>entity.id), (...ids)=>({
            childEntityIds: ids
        }))),
    attachComponent.withComponent(composedOfComponent, '$countertopItems', true).withEntity('Wall').attach(memoEval((self)=>self.$countertopItems.map((entity)=>entity.id), (...ids)=>({
            childEntityIds: ids
        }))),
    attachComponent.withComponent(attributeSwitchComponent, 'fullHeight', true).withEntity('Wall').attach(memoEval((self)=>[
            self.fullHeight
        ], (fullHeight)=>({
            value: fullHeight
        })), (state)=>{
        assertBoolean(state.value);
        return {
            fullHeight: state.value
        };
    }),
    attachComponent.withComponent(dimensionIndicatorComponent, 'wallLength', true).withEntity('Wall').withFilter((self)=>({
            navigationStates: [
                'Room'
            ],
            active: self.$active
        })).attach(memoEval((self)=>[
            self.$dimensionIndicatorWallStartX,
            self.$dimensionIndicatorWallEndX,
            self.$dimensionIndicatorWallLabel
        ], ($dimensionIndicatorWallStartX, $dimensionIndicatorWallEndX, $dimensionIndicatorWallLabel)=>({
            startX: $dimensionIndicatorWallStartX,
            startY: 0,
            startZ: 0,
            endX: $dimensionIndicatorWallEndX,
            endY: 0,
            endZ: 0,
            extrusionX: 0,
            extrusionY: 0,
            extrusionZ: 250,
            extrusionLineDashed: true,
            arrowHeadType: 'CONE',
            label: $dimensionIndicatorWallLabel
        }))),
    attachComponent.withComponent(dimensionIndicatorComponent, 'allCabinetsLength', true).withEntity('Wall').withFilter((self)=>({
            navigationStates: [
                'RoomContent',
                'Recipes',
                'Summary'
            ],
            active: self.$active
        })).attach(memoEval((self)=>[
            self.$dimensionIndicatorCabinetsStartX,
            self.$dimensionIndicatorCabinetsY,
            self.$dimensionIndicatorCabinetsEndX
        ], ($dimensionIndicatorCabinetsStartX, $dimensionIndicatorCabinetsY, $dimensionIndicatorCabinetsEndX)=>({
            startX: $dimensionIndicatorCabinetsStartX,
            startY: $dimensionIndicatorCabinetsY,
            startZ: 0,
            endX: $dimensionIndicatorCabinetsEndX,
            endY: $dimensionIndicatorCabinetsY,
            endZ: 0,
            extrusionX: 0,
            extrusionY: 475,
            extrusionZ: 0,
            extrusionLineDashed: true,
            arrowHeadType: 'CONE'
        }))),
    attachComponent.withComponent(dimensionIndicatorComponent, 'remainingLength', true).withEntity('Wall').withFilter((self)=>({
            navigationStates: [
                'RoomContent',
                'Recipes',
                'Summary'
            ],
            active: self.$dimensionIndicatorRemainingFilter
        })).attach(memoEval((self)=>[
            self.$dimensionIndicatorRemainingStartX,
            self.$dimensionIndicatorRemainingEndX,
            self.$dimensionIndicatorRemainingExtrusionZ
        ], ($dimensionIndicatorRemainingStartX, $dimensionIndicatorRemainingEndX, $dimensionIndicatorRemainingExtrusionZ)=>({
            startX: $dimensionIndicatorRemainingStartX,
            startY: 0,
            startZ: 0,
            endX: $dimensionIndicatorRemainingEndX,
            endY: 0,
            endZ: 0,
            extrusionX: 0,
            extrusionY: 0,
            extrusionZ: $dimensionIndicatorRemainingExtrusionZ,
            extrusionLineDashed: true,
            arrowHeadType: 'CONE'
        }))),
    attachComponent.withComponent(dimensionIndicatorComponent, 'allCabinetsLengthInFinalize', true).withEntity('Wall').withFilter((self)=>({
            navigationStates: [
                'Finalize'
            ],
            active: self.$active
        })).attach(memoEval((self)=>[
            self.$dimensionIndicatorCabinetsStartX,
            self.$dimensionIndicatorCabinetsY,
            self.$dimensionIndicatorCabinetsEndX,
            self.$dimensionIndicatorLabelFontSize
        ], ($dimensionIndicatorCabinetsStartX, $dimensionIndicatorCabinetsY, $dimensionIndicatorCabinetsEndX, $dimensionIndicatorLabelFontSize)=>({
            startX: $dimensionIndicatorCabinetsStartX,
            startY: $dimensionIndicatorCabinetsY,
            startZ: 0,
            endX: $dimensionIndicatorCabinetsEndX,
            endY: $dimensionIndicatorCabinetsY,
            endZ: 0,
            extrusionX: 0,
            extrusionY: 475,
            extrusionZ: 0,
            extrusionLineDashed: true,
            arrowHeadType: 'CONE',
            labelFontSize: $dimensionIndicatorLabelFontSize
        }))),
    attachComponent.withComponent(dimensionIndicatorComponent, 'cabinetHeight', true).withEntity('Wall').withFilter((self)=>({
            navigationStates: [
                'Finalize'
            ],
            active: self.$dimensionIndicatorCabinetHeightFilter
        })).attach(memoEval((self)=>[
            self.$dimensionIndicatorCabinetHeightX,
            self.$dimensionIndicatorCabinetHeightY,
            self.$dimensionIndicatorCabinetHeightExtrusionX,
            self.$dimensionIndicatorLabelFontSize
        ], ($dimensionIndicatorCabinetHeightX, $dimensionIndicatorCabinetHeightY, $dimensionIndicatorCabinetHeightExtrusionX, $dimensionIndicatorLabelFontSize)=>({
            startX: $dimensionIndicatorCabinetHeightX,
            startY: 0,
            startZ: 0,
            endX: $dimensionIndicatorCabinetHeightX,
            endY: $dimensionIndicatorCabinetHeightY,
            endZ: 0,
            extrusionX: $dimensionIndicatorCabinetHeightExtrusionX,
            extrusionLineDashed: true,
            arrowHeadType: 'CONE',
            labelFontSize: $dimensionIndicatorLabelFontSize
        }))),
    attachComponent.withComponent(distanceDimensionComponent, 'length', true).withEntity('Wall').attach(memoEval((self)=>[
            self.$minLength,
            self.length
        ], ($minLength, length)=>({
            min: $minLength,
            max: 600 * 25.4,
            value: length
        })), (state)=>{
        assertNumber(state.value);
        return {
            length: state.value
        };
    }),
    attachComponent.withComponent(sceneEntityPropertiesComponent, 'main', true).withEntity('Wall').attach(memoEval((self)=>[
            self.$rotationY,
            self.$x,
            self.$y,
            self.$z
        ], ($rotationY, $x, $y, $z)=>({
            rotationY: $rotationY,
            offsetX: $x,
            offsetY: $y,
            offsetZ: $z
        })))
];

//# sourceMappingURL=wall.js.map